// import EmailIcon from '@mui/icons-material/Email';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import {
//   Alert,
//   Box,
//   Button,
//   Checkbox,
//   Chip,
//   CircularProgress,
//   Container,
//   IconButton,
//   LinearProgress,
//   ListItemIcon,
//   ListItemText,
//   Menu,
//   MenuItem,
//   Paper,
//   Snackbar,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { useAppSelector } from 'app/hooks';
// import { useDrawer } from 'components/app/DrawerContext';
// import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import { FaFileAlt } from 'react-icons/fa';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   getBuySellCertificate,
//   manageTrustConfiguration,
//   selectGrowthUnitsCertificates,
//   selectIncomeUnitsCertificates,
//   selectLoading,
//   selectSendCertificatesLoading,
//   selectTrustConfig,
//   sendInvestorCertificates
// } from 'slices/fundManagementInvestment/fundManagementConfigurationSlice';
// import { AppDispatch } from 'store';
// import { CertificateData, generateCertificatePdfBase64Raw } from '../certificate/CertificateUtils';
// import CertificateViewer from '../certificate/CertificateViewer';

// interface CertificateRow {
//   certificateNo: string;
//   investorName?: string;
//   units: string;
//   value: string;
//   type: 'Growth' | 'Income';
//   date: string;
//   status: string;
//   id: string;
//   rawData: any;
// }

// const getUserDetails = () => {
//   const loginInfo = localStorage.getItem('user-details');
//   return loginInfo ? JSON.parse(loginInfo) : null;
// };

// const CertificateList: React.FC = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const dispatch = useDispatch<AppDispatch>();
//   const { fundManagementAdminRight } = useDrawer();
//   const [isAdmin] = useState(fundManagementAdminRight);

//   const growthCertificates = useSelector(selectGrowthUnitsCertificates);
//   const incomeCertificates = useSelector(selectIncomeUnitsCertificates);
//   const loading = useSelector(selectLoading);
//   const trustConfig = useSelector(selectTrustConfig);

//   const sendLoading = useSelector(selectSendCertificatesLoading);
//   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);

//   const [certificates, setCertificates] = useState<CertificateRow[]>([]);
//   const [selectedCertificate, setSelectedCertificate] = useState<CertificateRow | null>(null);
//   const [viewerOpen, setViewerOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [menuCertificate, setMenuCertificate] = useState<CertificateRow | null>(null);
//   const [selectedForEmail, setSelectedForEmail] = useState<Set<string>>(new Set());
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState<
//     'success' | 'error' | 'warning' | 'info'
//   >('success');

//   const investorEmail = useMemo(() => {
//     const user = getUserDetails();
//     return user?.email || '';
//   }, []);

//   const fetchKey = useRef<string>('');
//   const currentFetchKey = `${selectedProjectId}-${investorEmail}-${isAdmin}`;

//   const fetchCertificates = useCallback(() => {
//     if (selectedProjectId && investorEmail && currentFetchKey !== fetchKey.current) {
//       fetchKey.current = currentFetchKey;
//       dispatch(
//         getBuySellCertificate({
//           groupId: selectedProjectId,
//           serviceId: 'fundManagementInvestment',
//           investorEmail,
//           isAdmin
//         })
//       );
//     }
//   }, [selectedProjectId, investorEmail, isAdmin, dispatch, currentFetchKey]);

//   useEffect(() => {
//     fetchCertificates();
//   }, [fetchCertificates]);

//   // Load trust config (only once)
//   useEffect(() => {
//     if (selectedProjectId && investorEmail) {
//       dispatch(
//         manageTrustConfiguration({
//           action: 'get',
//           groupId: selectedProjectId,
//           serviceId: 'fundManagementInvestment',
//           isAdmin,
//           investorEmail
//         })
//       );
//     }
//   }, [dispatch, selectedProjectId, investorEmail, isAdmin]);

//   useEffect(() => {
//     const rows: CertificateRow[] = [];

//     const processCert = (cert: any) => {
//       if (!cert || !cert.id) return;

//       const date = new Date(cert.createdDateTime);

//       rows.push({
//         certificateNo: cert.id,
//         units: cert.totalUnitsHoldTillDate || '0',
//         value: `$${cert.amountInvestedTillDate || '0'}`,
//         type: cert.unitType === 'growthUnits' ? 'Growth' : 'Income',
//         date: date.toLocaleDateString('en-GB'),
//         status: 'Active',
//         id: cert.id,
//         rawData: cert
//       });
//     };

//     growthCertificates.forEach(processCert);
//     incomeCertificates.forEach(processCert);

//     setCertificates(rows);
//   }, [growthCertificates, incomeCertificates]);

//   const createCertificateData = (cert: CertificateRow): CertificateData => ({
//     certificateNumber: cert.id,
//     unitType: cert.type,
//     unitHolder: cert.rawData.investorName || 'Investor',
//     units: parseFloat(cert.units),
//     price: parseFloat(cert.rawData.currentUnitPrice),
//     date: cert.date,
//     beneficiary: cert.rawData.investorName || 'Investor',
//     trustee: 'Unity Prosperity Trust Trustee',
//     action: 'certificate',
//     dateOfRegistration: cert.date,
//     executionDate: cert.date,
//     trustName: trustConfig?.trustName || 'Unity Prosperity Trust',
//     trustDeedExecutionDate: trustConfig?.trustDeedExecutionDate || cert.date,
//     trustFundManagerSignatureBase64: trustConfig?.trustFundManagerSignatureBase64 || null,
//     investorSignatureBase64: trustConfig?.investorSignatureBase64 || null
//   });

//   const validateSignatures = () => {
//     if (!trustConfig?.investorSignatureBase64) {
//       return { severity: 'error' as const, message: 'Investor signature missing in your profile.' };
//     }
//     if (!trustConfig?.trustFundManagerSignatureBase64) {
//       return {
//         severity: 'warning' as const,
//         message: 'Fund manager signature missing. Certificate will be sent without it.'
//       };
//     }
//     return null;
//   };

//   const generateCertificatePayload = async (cert: CertificateRow) => {
//     console.log('cert', cert);
//     const data = createCertificateData(cert);
//     const base64 = await generateCertificatePdfBase64Raw(data);

//     return {
//       investorEmail:
//         cert?.rawData?.investorsEmailId || cert?.rawData?.investorEmail || investorEmail,
//       investorName: cert.rawData.investorName || '',
//       trustName: trustConfig?.trustName || '',
//       certificateBase64: base64,
//       fundManagerName: cert.rawData.investorName,
//       unitsHeld: cert.units,
//       date: cert.date.includes('/') ? cert.date.split('/').reverse().join('-') : cert.date,
//       unitType: cert.type === 'Growth' ? 'Growth Units' : 'Income Units',
//       certificateNumber: cert.certificateNo
//     };
//   };

//   const showSnackbar = (
//     msg: string,
//     severity: 'success' | 'error' | 'warning' | 'info' = 'success'
//   ) => {
//     setSnackbarMessage(msg);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   const handleSendCertificates = async (certs: CertificateRow[], clearSelection = true) => {
//     const validation = validateSignatures();
//     if (validation?.severity === 'error') {
//       showSnackbar(validation.message, 'error');
//       return;
//     }
//     if (validation?.severity === 'warning') {
//       showSnackbar(validation.message, 'warning');
//     }

//     if (certs.length === 0) {
//       showSnackbar('No certificates to send', 'info');
//       return;
//     }

//     try {
//       const payloads = await Promise.all(
//         certs.map((cert) => generateCertificatePayload(cert).catch(() => null))
//       );

//       console.log('payloads', payloads);
//       const validPayloads = payloads.filter((p): p is NonNullable<typeof p> => p !== null);

//       if (validPayloads.length === 0) {
//         showSnackbar('Failed to generate any certificates', 'error');
//         return;
//       }

//       await dispatch(sendInvestorCertificates({ certificatesData: validPayloads }));
//       showSnackbar(
//         `Successfully sent ${validPayloads.length} certificate${
//           validPayloads.length > 1 ? 's' : ''
//         }!`,
//         'success'
//       );
//       if (clearSelection) setSelectedForEmail(new Set());
//     } catch (err) {
//       showSnackbar('Failed to send certificate(s)', 'error');
//     }
//   };

//   const handleBulkSend = () => {
//     const selectedIds = Array.from(selectedForEmail);
//     if (selectedIds.length === 0) {
//       showSnackbar('Select at least one certificate', 'info');
//       return;
//     }
//     const selectedCerts = certificates.filter((c) => selectedIds.includes(c.id));
//     handleSendCertificates(selectedCerts);
//   };

//   const handleSingleSend = (cert: CertificateRow) => {
//     handleSendCertificates([cert], false);
//     handleMenuClose();
//   };

//   const handleSelect = (id: string) => {
//     const newSet = new Set(selectedForEmail);
//     newSet.has(id) ? newSet.delete(id) : newSet.add(id);
//     setSelectedForEmail(newSet);
//   };

//   const handleSelectAll = () => {
//     setSelectedForEmail(
//       selectedForEmail.size === certificates.length
//         ? new Set()
//         : new Set(certificates.map((c) => c.id))
//     );
//   };

//   const handleMenuOpen = (e: React.MouseEvent<HTMLElement>, cert: CertificateRow) => {
//     setAnchorEl(e.currentTarget);
//     setMenuCertificate(cert);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setMenuCertificate(null);
//   };

//   const handleView = (cert: CertificateRow) => {
//     setSelectedCertificate(cert);
//     setViewerOpen(true);
//     handleMenuClose();
//   };

//   if (loading) {
//     return (
//       <Container maxWidth="xl" sx={{ py: 8, textAlign: 'center' }}>
//         <CircularProgress />
//         <Typography variant="body2" sx={{ mt: 2 }}>
//           Loading certificates...
//         </Typography>
//       </Container>
//     );
//   }

//   console.log('selectedCertificate', certificates);

//   return (
//     <>
//       <Container maxWidth="xl" sx={{ py: 3 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, flexWrap: 'wrap', gap: 2 }}>
//           <Box
//             sx={{
//               width: 40,
//               height: 40,
//               borderRadius: 2,
//               background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center'
//             }}
//           >
//             <FaFileAlt size={20} color="white" />
//           </Box>
//           <Box flex={1}>
//             <Typography variant="h6" sx={{ fontWeight: 500 }}>
//               My Certificates
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               View, download, or email your investment certificates
//             </Typography>
//           </Box>

//           {selectedForEmail.size > 0 && (
//             <Button
//               variant="contained"
//               color="primary"
//               startIcon={<EmailIcon />}
//               onClick={handleBulkSend}
//               disabled={sendLoading}
//             >
//               {sendLoading ? (
//                 <>Sending {selectedForEmail.size}...</>
//               ) : (
//                 <>Send {selectedForEmail.size} Selected</>
//               )}
//             </Button>
//           )}
//         </Box>

//         {sendLoading && <LinearProgress sx={{ mb: 2 }} />}

//         <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
//           <TableContainer sx={{ maxHeight: '70vh' }}>
//             <Table stickyHeader>
//               <TableHead>
//                 <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
//                   <TableCell padding="checkbox">
//                     <Checkbox
//                       indeterminate={
//                         selectedForEmail.size > 0 && selectedForEmail.size < certificates.length
//                       }
//                       checked={
//                         certificates.length > 0 && selectedForEmail.size === certificates.length
//                       }
//                       onChange={handleSelectAll}
//                     />
//                   </TableCell>
//                   {[
//                     'Certificate No.',
//                     'Investor Name',
//                     'Units',
//                     'Type',
//                     'Date',
//                     'Status',
//                     'Actions'
//                   ].map((h) => (
//                     <TableCell key={h} sx={{ fontWeight: 600 }}>
//                       {h}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {certificates.length === 0 ? (
//                   <TableRow>
//                     <TableCell colSpan={8} align="center" sx={{ py: 6 }}>
//                       <Typography color="text.secondary">No certificates found</Typography>
//                       <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                         Your investment certificates will appear here once issued
//                       </Typography>
//                     </TableCell>
//                   </TableRow>
//                 ) : (
//                   certificates.map((cert) => (
//                     <TableRow
//                       key={cert.id}
//                       hover
//                       sx={{ cursor: 'pointer' }}
//                       onClick={(e) => {
//                         if (
//                           (e.target as HTMLElement).closest('input[type="checkbox"]') ||
//                           (e.target as HTMLElement).closest('button')
//                         ) {
//                           return;
//                         }
//                         handleView(cert);
//                       }}
//                     >
//                       <TableCell padding="checkbox">
//                         <Checkbox
//                           checked={selectedForEmail.has(cert.id)}
//                           onChange={() => handleSelect(cert.id)}
//                         />
//                       </TableCell>
//                       <TableCell>{cert.id}</TableCell>
//                       <TableCell>{cert?.rawData?.investorName}</TableCell>
//                       <TableCell>{cert.units}</TableCell>
//                       <TableCell>
//                         <Chip
//                           label={cert.type}
//                           size="small"
//                           color={cert.type === 'Growth' ? 'success' : 'primary'}
//                           variant="outlined"
//                         />
//                       </TableCell>
//                       <TableCell>{cert.date}</TableCell>
//                       <TableCell>
//                         <Chip label="Active" color="success" size="small" />
//                       </TableCell>
//                       <TableCell align="center">
//                         <IconButton size="small" onClick={(e) => handleMenuOpen(e, cert)}>
//                           <MoreVertIcon fontSize="small" />
//                         </IconButton>
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Paper>

//         <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
//           <MenuItem onClick={() => menuCertificate && handleView(menuCertificate)}>
//             <ListItemIcon>
//               <VisibilityIcon fontSize="small" />
//             </ListItemIcon>
//             <ListItemText>View & Download</ListItemText>
//           </MenuItem>
//           <MenuItem onClick={() => menuCertificate && handleSingleSend(menuCertificate)}>
//             <ListItemIcon>
//               <EmailIcon fontSize="small" />
//             </ListItemIcon>
//             <ListItemText>Send to Email</ListItemText>
//           </MenuItem>
//         </Menu>
//       </Container>

//       {viewerOpen && selectedCertificate && (
//         <CertificateViewer
//           certificateData={createCertificateData(selectedCertificate)}
//           rawCertificate={selectedCertificate.rawData}
//           onClose={() => {
//             setViewerOpen(false);
//             setSelectedCertificate(null);
//           }}
//           mode="preview"
//         />
//       )}

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: '100%' }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default CertificateList;




// src/components/fundManagement/reports/CertificateList.tsx
import EmailIcon from '@mui/icons-material/Email';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  IconButton,
  LinearProgress,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useAppSelector } from 'app/hooks';
import { useDrawer } from 'components/app/DrawerContext';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FaFileAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBuySellCertificate,
  manageTrustConfiguration,
  selectGrowthUnitsCertificates,
  selectIncomeUnitsCertificates,
  selectLoading,
  selectSendCertificatesLoading,
  selectTrustConfig,
  sendInvestorCertificates
} from 'slices/fundManagementInvestment/fundManagementConfigurationSlice';
import { AppDispatch } from 'store';
import { CertificateData, generateCertificatePdfBase64Raw } from '../certificate/CertificateUtils';
import CertificateViewer from '../certificate/CertificateViewer';

interface CertificateRow {
  certificateNo: string;
  investorName?: string;
  units: string;
  value: string;
  type: 'Growth' | 'Income';
  date: string;
  status: string;
  id: string;
  rawData: any;
}

const getUserDetails = () => {
  const loginInfo = localStorage.getItem('user-details');
  return loginInfo ? JSON.parse(loginInfo) : null;
};

const CertificateList: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch<AppDispatch>();
  const { fundManagementAdminRight } = useDrawer();
  const [isAdmin] = useState(fundManagementAdminRight);

  const growthCertificates = useSelector(selectGrowthUnitsCertificates);
  const incomeCertificates = useSelector(selectIncomeUnitsCertificates);
  const loading = useSelector(selectLoading);
  const trustConfig = useSelector(selectTrustConfig);
  const sendLoading = useSelector(selectSendCertificatesLoading);
  const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);

  const [certificates, setCertificates] = useState<CertificateRow[]>([]);
  const [selectedCertificate, setSelectedCertificate] = useState<CertificateRow | null>(null);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuCertificate, setMenuCertificate] = useState<CertificateRow | null>(null);
  const [selectedForEmail, setSelectedForEmail] = useState<Set<string>>(new Set());
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'warning' | 'info'>('success');

  const investorEmail = useMemo(() => {
    const user = getUserDetails();
    return user?.email || '';
  }, []);

  const fetchKey = useRef<string>('');
  const currentFetchKey = `${selectedProjectId}-${investorEmail}-${isAdmin}`;

  const fetchCertificates = useCallback(() => {
    if (selectedProjectId && investorEmail && currentFetchKey !== fetchKey.current) {
      fetchKey.current = currentFetchKey;
      dispatch(
        getBuySellCertificate({
          groupId: selectedProjectId,
          serviceId: 'fundManagementInvestment',
          investorEmail,
          isAdmin
        })
      );
    }
  }, [selectedProjectId, investorEmail, isAdmin, dispatch, currentFetchKey]);

  useEffect(() => {
    fetchCertificates();
  }, [fetchCertificates]);

  useEffect(() => {
    if (selectedProjectId && investorEmail) {
      dispatch(
        manageTrustConfiguration({
          action: 'get',
          groupId: selectedProjectId,
          serviceId: 'fundManagementInvestment',
          isAdmin,
          investorEmail
        })
      );
    }
  }, [dispatch, selectedProjectId, investorEmail, isAdmin]);

  useEffect(() => {
    const rows: CertificateRow[] = [];
    const processCert = (cert: any) => {
      if (!cert || !cert.id) return;
      const date = new Date(cert.createdDateTime);
      rows.push({
        certificateNo: cert.id,
        units: cert.totalUnitsHoldTillDate || '0',
        value: `$${cert.amountInvestedTillDate || '0'}`,
        type: cert.unitType === 'growthUnits' ? 'Growth' : 'Income',
        date: date.toLocaleDateString('en-GB'),
        status: 'Active',
        id: cert.id,
        rawData: cert
      });
    };
    growthCertificates.forEach(processCert);
    incomeCertificates.forEach(processCert);
    setCertificates(rows);
  }, [growthCertificates, incomeCertificates]);

  const createCertificateData = (cert: CertificateRow): CertificateData => ({
    certificateNumber: cert.id,
    unitType: cert.type,
    unitHolder: cert.rawData.investorName || 'Investor',
    units: parseFloat(cert.units),
    price: parseFloat(cert.rawData.currentUnitPrice || 0),
    date: cert.date,
    beneficiary: cert.rawData.investorName || 'Investor',
    trustee: 'Unity Prosperity Trust Trustee',
    action: 'certificate',
    dateOfRegistration: cert.date,
    executionDate: cert.date,
    trustName: trustConfig?.trustName || 'Unity Prosperity Trust',
    trustDeedExecutionDate: trustConfig?.trustDeedExecutionDate || cert.date,
    trustFundManagerSignatureBase64: trustConfig?.trustFundManagerSignatureBase64 || null,
    investorSignatureBase64: trustConfig?.investorSignatureBase64 || null
  });

  const validateSignatures = () => {
    if (!trustConfig?.investorSignatureBase64) {
      return { severity: 'error' as const, message: 'Investor signature missing in your profile.' };
    }
    if (!trustConfig?.trustFundManagerSignatureBase64) {
      return { severity: 'warning' as const, message: 'Fund manager signature missing. Certificate will be sent without it.' };
    }
    return null;
  };

  const generateCertificatePayload = async (cert: CertificateRow) => {
    const data = createCertificateData(cert);
    const base64 = await generateCertificatePdfBase64Raw(data);

    const [day, month, year] = cert.date.split('/');
    const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

    return {
      investorEmail: investorEmail,
      investorName: cert.rawData.investorName || 'Investor',
      trustName: trustConfig?.trustName || 'Unity Prosperity Trust',
      certificateBase64: base64,
      fundManagerName: trustConfig?.fundManagerName || 'Mr. Yosh New Admin',
      unitsHeld: cert.units.toString(),
      date: isoDate,
      unitType: cert.type === 'Growth' ? 'Growth Units' : 'Income Units',
      certificateNumber: cert.certificateNo
    };
  };

  const showSnackbar = (msg: string, severity: 'success' | 'error' | 'warning' | 'info' = 'success') => {
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSendCertificates = async (certs: CertificateRow[], clearSelection = true) => {
    const validation = validateSignatures();
    if (validation?.severity === 'error') return showSnackbar(validation.message, 'error');
    if (validation?.severity === 'warning') showSnackbar(validation.message, 'warning');

    if (certs.length === 0) return showSnackbar('No certificates selected', 'info');

    showSnackbar(`Generating ${certs.length} PDF(s)...`, 'info');

    try {
      const results = await Promise.all(
        certs.map(async (cert, i) => {
          try {
            console.log(`Generating PDF ${i + 1}/${certs.length}: ${cert.certificateNo}`);
            const payload = await Promise.race([
              generateCertificatePayload(cert),
              new Promise<never>((_, reject) => setTimeout(() => reject(new Error('Timeout')), 20000))
            ]);
            console.log(`PDF ${i + 1} ready`);
            return payload;
          } catch (err) {
            console.error(`Failed: ${cert.certificateNo}`, err);
            return null;
          }
        })
      );

      const validPayloads = results.filter(Boolean) as any[];

      if (validPayloads.length === 0) {
        return showSnackbar('All PDFs failed to generate', 'error');
      }

      console.log('Sending bulk →', validPayloads.length, 'certificates');
      await dispatch(sendInvestorCertificates({ certificatesData: validPayloads })).unwrap();

      showSnackbar(`Successfully sent ${validPayloads.length} certificate(s)!`, 'success');
      if (clearSelection) setSelectedForEmail(new Set());
    } catch (err: any) {
      console.error('Bulk send failed:', err);
      showSnackbar(err.message || 'Failed to send certificates', 'error');
    }
  };

  const handleBulkSend = () => {
    const selectedIds = Array.from(selectedForEmail);
    if (selectedIds.length === 0) return showSnackbar('Please select at least one certificate', 'info');
    const selectedCerts = certificates.filter(c => selectedIds.includes(c.id));
    handleSendCertificates(selectedCerts);
  };

  const handleSingleSend = (cert: CertificateRow) => {
    handleSendCertificates([cert], false);
    handleMenuClose();
  };

  const handleSelect = (id: string) => {
    const newSet = new Set(selectedForEmail);
    newSet.has(id) ? newSet.delete(id) : newSet.add(id);
    setSelectedForEmail(newSet);
  };

  const handleSelectAll = () => {
    setSelectedForEmail(
      selectedForEmail.size === certificates.length
        ? new Set()
        : new Set(certificates.map(c => c.id))
    );
  };

  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>, cert: CertificateRow) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setMenuCertificate(cert);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuCertificate(null);
  };

  const handleView = (cert: CertificateRow) => {
    setSelectedCertificate(cert);
    setViewerOpen(true);
    handleMenuClose();
  };

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: 8, textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="body2" sx={{ mt: 2 }}>Loading certificates...</Typography>
      </Container>
    );
  }

  return (
    <>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ width: 40, height: 40, borderRadius: 2, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <FaFileAlt size={20} color="white" />
          </Box>
          <Box flex={1}>
            <Typography variant="h6" sx={{ fontWeight: 500 }}>My Certificates</Typography>
            <Typography variant="body2" color="text.secondary">
              View, download, or email your investment certificates
            </Typography>
          </Box>

          {selectedForEmail.size > 0 && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<EmailIcon />}
              onClick={handleBulkSend}
              disabled={sendLoading}
              size="large"
            >
              {sendLoading ? `Sending ${selectedForEmail.size}...` : `Send ${selectedForEmail.size} Selected`}
            </Button>
          )}
        </Box>

        {sendLoading && <LinearProgress sx={{ mb: 2 }} />}

        <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: '70vh' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={selectedForEmail.size > 0 && selectedForEmail.size < certificates.length}
                      checked={certificates.length > 0 && selectedForEmail.size === certificates.length}
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  {['Certificate No.', 'Investor Name', 'Units', 'Type', 'Date', 'Status', 'Actions'].map((h) => (
                    <TableCell key={h} sx={{ fontWeight: 600 }}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {certificates.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 6 }}>
                      <Typography color="text.secondary">No certificates found</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Your investment certificates will appear here once issued
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  certificates.map((cert) => (
                    <TableRow
                      key={cert.id}
                      hover
                      sx={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        const target = e.target as HTMLElement;
                        if (target.closest('input[type="checkbox"]') || target.closest('button')) return;
                        handleView(cert);
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedForEmail.has(cert.id)}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleSelect(cert.id);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </TableCell>
                      <TableCell>{cert.certificateNo}</TableCell>
                      <TableCell>{cert.rawData?.investorName || '—'}</TableCell>
                      <TableCell>{cert.units}</TableCell>
                      <TableCell>
                        <Chip label={cert.type} size="small" color={cert.type === 'Growth' ? 'success' : 'primary'} variant="outlined" />
                      </TableCell>
                      <TableCell>{cert.date}</TableCell>
                      <TableCell><Chip label="Active" color="success" size="small" /></TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={(e) => handleMenuOpen(e, cert)}>
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
          <MenuItem onClick={() => menuCertificate && handleView(menuCertificate)}>
            <ListItemIcon><VisibilityIcon fontSize="small" /></ListItemIcon>
            <ListItemText>View & Download</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => menuCertificate && handleSingleSend(menuCertificate)}>
            <ListItemIcon><EmailIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Send to Email</ListItemText>
          </MenuItem>
        </Menu>
      </Container>

      {viewerOpen && selectedCertificate && (
        <CertificateViewer
          certificateData={createCertificateData(selectedCertificate)}
          rawCertificate={selectedCertificate.rawData}
          onClose={() => {
            setViewerOpen(false);
            setSelectedCertificate(null);
          }}
          mode="preview"
        />
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} variant="filled">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CertificateList;